import styled from 'styled-components';

export const Container = styled.div`
`;

export const RecipeGroup = styled.div`
  padding-top: 5px;
`;